import React from 'react';
import { Rocket } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="relative py-12 px-6 border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col items-center justify-center space-y-4">
          <div className="flex items-center space-x-2">
            {/* <Rocket className="w-6 h-6 text-[#00E5FF]" /> */}
            <span className="text-xl font-bold">Jupiter Cosmic</span>
          </div>
          <p className="text-sm text-gray-400">Engineering Digital Gravity.</p>
          <p className="text-sm text-gray-500">© 2026 Jupiter Cosmic. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
